import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        defaultProjectLabelPrinter: null,
        defaultDocumentPrinter: null,
        defaultPostCardPrinter: null,
    },
    mutations: {
        setDefaultProjectLabelPrinter(state, value) {
            Vue.set(state, 'defaultProjectLabelPrinter', value);
        },
        setDefaultDocumentPrinter(state, value){
            Vue.set(state, 'defaultDocumentPrinter', value);
        },
        setDefaultPostCardPrinter(state, value){
            Vue.set(state, 'defaultPostCardPrinter', value);
        }
    },
    actions: {
        setDefaultProjectLabelPrinter({ commit }, value) {
            commit('setDefaultProjectLabelPrinter', value);
        },
        setDefaultDocumentPrinter({ commit }, value) {
            commit('setDefaultDocumentPrinter', value);
        },
        setDefaultPostCardPrinter({ commit }, value){
            commit('setDefaultPostCardPrinter', value);
        }
    },
    getters: {
        getDefaultProjectLabelPrinter: (state) => state.defaultProjectLabelPrinter,
        getDefaultDocumentPrinter: (state) => state.defaultDocumentPrinter,
        getDefaultPostCardPrinter: (state) => state.defaultPostCardPrinter,
    },
}
